/**
 * Constants for map layer tree node identifiers
 */
export const TREE_NODE_IDS = {
  STATIC_LAYERS: "static-layers",
  MY_DATA: "my-data",
  MY_DATA_INPUT: "my-data-input",
  MY_DATA_INPUT_GROUP: "my-data-input-group",
  VISUALIZATION_MODE: "visualization-mode",
} as const;

/**
 * Prefix used for group node values in the tree
 */
export const GROUP_PREFIX = "group-";

/**
 * Prefix used for processed GeoJSON layer IDs
 */
export const PROCESSED_LAYER_PREFIX = "processed-";

